// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  userId: __t.u64().primaryKey().name("user_id"),
  lastMessageAt: __t.u64().name("last_message_at"),
  lastMessageHash: __t.u64().name("last_message_hash"),
  spamStrikes: __t.u32().name("spam_strikes"),
  mutedUntil: __t.u64().name("muted_until"),
});
